import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { IPrice } from '@shared/jp/data/products';
import { MediaService } from '@studiobuki/web-core/lib/media';

@Component({
  selector: 'app-product[id][title][specs][photo]',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductComponent {
  @Input() id!: string;

  @Input() title!: string;

  /** supports html tags */
  @Input() subtitle!: string;

  @Input() specs!: { [key: string]: string };

  @Input() price: IPrice | undefined;

  @Input() photo!: string;

  @Input() discount: string | undefined | null;

  constructor(public media: MediaService) {}
}
